import { Component, Input, ContentChildren, QueryList } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators/take';
import { saveAs } from '@progress/kendo-file-saver';
import { toDataURL, workbookOptions, ColumnBase } from '@progress/kendo-angular-excel-export';
import { ExcelService } from './excel.service';
import { ExcelExportEvent } from './excel-export-event';
import { LocalizationService } from '@progress/kendo-angular-l10n';
import { orderBy } from '@progress/kendo-data-query';
import { sortColumns } from '../columns/column-common';
/* tslint:disable object-literal-sort-keys */
var fetchComponentData = function (component) {
    return {
        data: component.view.map(function (item) { return item; }),
        group: component.group
    };
};
var toExcelColumn = function (column) {
    return {
        title: column.title,
        field: column.field,
        locked: Boolean(column.locked),
        width: column.width,
        level: column.level,
        groupHeaderTemplate: column.groupHeaderTemplate,
        groupFooterTemplate: column.groupFooterTemplate,
        footerTemplate: column.footerTemplate
    };
};
var toExcelColumns = function (columns) {
    var result = [];
    sortColumns(columns)
        .forEach(function (column) {
        if (column.isVisible) {
            if (column.childColumns) {
                result.push.apply(result, toExcelColumns(column.childColumns.toArray()));
            }
            else {
                var excelColumn = toExcelColumn(column);
                if (column.children) {
                    excelColumn.children = toExcelColumns(column.children.toArray().slice(1));
                }
                result.push(excelColumn);
            }
        }
    });
    return result;
};
var componentColumns = function (component) {
    var columns = toExcelColumns(component.columns.toArray());
    return orderBy(columns, [{ field: 'locked', dir: 'desc' }]);
};
/**
 * Configures the Excel export settings of the Kendo UI Grid.
 *
 * For more information, refer to the article on
 * [exporting the Grid to Excel]({% slug excelexport_grid %}).
 */
var ExcelComponent = /** @class */ (function () {
    function ExcelComponent(excelService, localization) {
        this.localization = localization;
        /**
         * Specifies the file name of the exported Excel file.
         * @default "Export.xlsx"
         */
        this.fileName = 'Export.xlsx';
        /**
         * @hidden
         */
        this.columns = new QueryList();
        this.saveSubscription = excelService.saveToExcel.subscribe(this.save.bind(this));
    }
    ExcelComponent.prototype.ngOnDestroy = function () {
        this.saveSubscription.unsubscribe();
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
    };
    ExcelComponent.prototype.save = function (component) {
        var _this = this;
        var data = (this.fetchData || fetchComponentData)(component);
        var exportData = function (result) {
            delete _this.dataSubscription;
            _this.exportData(component, result);
        };
        if (data instanceof Promise) {
            data.then(exportData);
        }
        else if (data instanceof Observable) {
            this.dataSubscription = data.pipe(take(1)).subscribe(exportData);
        }
        else {
            exportData(data);
        }
    };
    ExcelComponent.prototype.exportData = function (component, result) {
        var options = workbookOptions({
            columns: this.columns.length ? this.columns : componentColumns(component),
            data: result.data,
            group: result.group,
            filterable: this.filterable,
            creator: this.creator,
            date: this.date,
            paddingCellOptions: this.paddingCellOptions,
            headerPaddingCellOptions: this.headerPaddingCellOptions,
            rtl: this.localization.rtl
        });
        var args = new ExcelExportEvent(options);
        component.excelExport.emit(args);
        if (!args.isDefaultPrevented()) {
            this.saveFile(options);
        }
    };
    ExcelComponent.prototype.saveFile = function (options) {
        var _this = this;
        toDataURL(options).then(function (dataURL) {
            saveAs(dataURL, _this.fileName, {
                forceProxy: _this.forceProxy,
                proxyURL: _this.proxyURL
            });
        });
    };
    ExcelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'kendo-grid-excel',
                    template: ""
                },] },
    ];
    /** @nocollapse */
    ExcelComponent.ctorParameters = function () { return [
        { type: ExcelService, },
        { type: LocalizationService, },
    ]; };
    ExcelComponent.propDecorators = {
        'fileName': [{ type: Input },],
        'filterable': [{ type: Input },],
        'creator': [{ type: Input },],
        'date': [{ type: Input },],
        'forceProxy': [{ type: Input },],
        'proxyURL': [{ type: Input },],
        'fetchData': [{ type: Input },],
        'paddingCellOptions': [{ type: Input },],
        'headerPaddingCellOptions': [{ type: Input },],
        'columns': [{ type: ContentChildren, args: [ColumnBase, { descendants: true },] },],
    };
    return ExcelComponent;
}());
export { ExcelComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/excel/excel.component.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/excel/excel.component.js
// module chunks = vendor